import * as React from 'react';

import { cn, Switch, Tooltip } from '@rematter/ui-web';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';
import { WeightUnitType } from '~/modules/trade/types/load';

type WeightUnitSwitchProps = {
  value: WeightUnitType;
  showTooltip?: boolean;
  onChange: (value: WeightUnitType) => void;
};

export const WeightUnitSwitch = ({
  value,
  showTooltip = false,
  onChange,
}: WeightUnitSwitchProps) => {
  const t = useTranslations();

  return (
    <Tooltip
      tip={t.itemTable.weightUnitSwitch.disabledTooltip}
      isDisabled={!showTooltip}
      wrapWithButton={false}
      placement="top"
      className="@WeightUnitSwitchWrapper"
    >
      <div
        className={cn(
          '@WeightUnitSwitch rounded-md border border-neutral/10 bg-neutral/5 px-3 py-2',
        )}
      >
        <Switch
          isSelected={value === 'price'}
          onChange={(isSelected: boolean) => {
            onChange(isSelected ? 'price' : 'scale');
          }}
          className="flex items-center gap-2"
        >
          <span>
            {t.itemTable.weightUnitSwitch.prefix}{' '}
            <strong>{t.itemTable.weightUnitSwitch.pricing}</strong>{' '}
            {t.itemTable.weightUnitSwitch.suffix}
          </span>
        </Switch>
      </div>
    </Tooltip>
  );
};
